 
import Vue from 'vue' //引入vue
 
import App from './App'  //引入App
 
import VueRouter from 'vue-router'  //引入VueRouter
 
import router from './router'  //引入路由器
import 'jquery/dist/jquery.min'
 
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/js/index.esm'

 
Vue.config.productionTip = false   //关闭vue生产提示

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.use(VueRouter)  //应用插件
 
//创建vm
new Vue({
  el:'#app',
  render:h => h(App),
  router:router,
  
})